import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {getHomePageUrl} from '../../../../../../commons/selectors/environment'
import {useAppSelector} from '../../../hooks/runtime'
import {RegistrationButtonSkin} from '../../registration-buttons/registration-button-skin'

export const BackToSiteButton = ({text}: {text?: string}) => {
  const {t} = useTranslation()
  const url = useAppSelector(getHomePageUrl)

  if (!url) {
    return null
  }

  return <RegistrationButtonSkin text={text ?? t('backToSite')} dataHook={DH.BACK_TO_SITE} url={url} />
}
